import classnames from 'classnames';
import React from 'react';

interface Props {
  status: 'Draft' | 'Open' | 'Closed';
}

const RFIOverlayStatusBar: React.FC<Props> = (props: Props) => {
  const { status } = props;

  return (
    <div>
      <div className="medium size-16 black-2 hrem-3 row items-center">
        Status
      </div>
      <div
        className={classnames('px3 py1 font-size-4 regular flex-center', {
          'b-2': status === 'Draft',
          'b-radius-3 bgd-status-red black-1': status === 'Open',
          'b-radius-3 bgd-light-grey-1 black-1': status === 'Closed',
        })}
      >
        {status}
      </div>
    </div>
  );
};

export default RFIOverlayStatusBar;
